export default __webpack_public_path__ + "static/media/0aa6949f5110279364f3b779b4653137.jpg";